export default {
  isLoading: false
};
